'use client';

import { ConvexProvider, ConvexReactClient } from 'convex/react';
import { ConsentProvider } from '@/lib/consent/consent-context';
import type { ReactNode } from 'react';

const convex = new ConvexReactClient(process.env.NEXT_PUBLIC_CONVEX_URL!);

export const Providers = ({ children }: { children: ReactNode }) => {
  return (
    <ConvexProvider client={convex}>
      <ConsentProvider>{children}</ConsentProvider>
    </ConvexProvider>
  );
};
